export default __webpack_public_path__ + "static/media/screen_livechat_11.4d1b8779.png";